import { render, staticRenderFns } from "./EntityTaskList.vue?vue&type=template&id=84acf986&scoped=true&"
import script from "./EntityTaskList.vue?vue&type=script&lang=js&"
export * from "./EntityTaskList.vue?vue&type=script&lang=js&"
import style0 from "./EntityTaskList.vue?vue&type=style&index=0&id=84acf986&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84acf986",
  null
  
)

export default component.exports